import firebase from "firebase/app";

import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";
import importStatuses from "astrid-firestore/src/api/imports/constants/importStatuses";
import updateImport from "astrid-firestore/src/api/imports/updateImport";

import { getOrganizationPath } from "../../routing/utils/getOrganizationPath";

export default function useImportDropdownMenuOptions() {
	const { t } = useTranslation();

	return (theImport) => {
		const ref = db.collection("imports").doc(theImport.id);

		const linkTo = getLinkForSubject(theImport.subject);

		return [
			{
				text: t("retry", "Retry"),
				action: () => {
					return updateImport(firebase, ref, {
						status: importStatuses.PENDING,
						forceCover: true,
					});
				},
			},
			{
				text: t("viewSubject", "View subject"),
				linkTo,
				disabled: !linkTo,
			},
			{
				text: t("markAsCompleted", "Mark as completed"),
				disabled: theImport.status === importStatuses.COMPLETED,
				action: () => {
					return updateImport(firebase, ref, { status: importStatuses.COMPLETED });
				},
			},
		];
	};
}

function getLinkForSubject(subject) {
	if (!subject) return null;

	const subjectType = subject.ref.path.split("/")[0];

	switch (subjectType) {
		case "articles":
			return getOrganizationPath(`/${subject.ref.path}`);
		case "productions":
			return `/production/${subject.ref.id}`;
		default:
			return null;
	}
}
